import { ref, computed } from 'vue';
import { defineStore } from 'pinia'

export let useRegionalNavigationStore = defineStore('regionalNavigationStore', () => {
  const region = ref({
    name: 'World',
    lat: 0,
    lon: 0,
    zoom: 0,
    subRegions: null,
    path: [],
    position: []
  })

  const updateRegion = (newRegion) => {
    region.value = Object.assign({}, region.value, newRegion)
  }

  const changeRegion = (centerZoom) => {
    const [lat, lng, zoom] = centerZoom.split(',')
    const center = new google.maps.LatLng(lat, lng)
    window.$EventBus.dispatchEvent('map-center-changed', { center, zoom: parseInt(zoom) })
  }  

  return {
    region,
    updateRegion,
    changeRegion
  }
})
